import { render, staticRenderFns } from "./OrderPaymentAssertDialog.vue?vue&type=template&id=532ff6e9&scoped=true"
import script from "./OrderPaymentAssertDialog.vue?vue&type=script&lang=ts"
export * from "./OrderPaymentAssertDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ff6e9",
  null
  
)

export default component.exports